import { AllZonesResponseModel, ZoneDropDownDto, ZoneDropDownResponseModel, ZoneResponseModel } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { ZoneMasterDTO } from './dto/zone.dto';
import { ZoneRequest } from './dto/zone.request';
import { ZoneMasterService } from './zone-master.service';
import { PlantIdRequest } from '@gtpl/shared-models/masters';
import { PlantRequest } from './dto/plant.request';
@ApiTags('Zone Master')
@Controller('zone-master')
export class ZoneMasterController {
    constructor(
        private zoneMasterService: ZoneMasterService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

      ){}
      /**
       * create or update Zone
       * @param zoneMasterDTO 
       * @param isUpdate 
       * @param request 
       */
    @Post('/createZone')
    async createZone(@Body() zoneMasterDTO:ZoneMasterDTO,isUpdate:boolean=false,@Req() request:Request): Promise<ZoneResponseModel> {
        try {
            // console.log(zoneMasterDTO);
            return await this.zoneMasterService.createZone(zoneMasterDTO, false,request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(ZoneResponseModel, error)
        }
    }
    /**
     * create or update Zone
     * @param zoneMasterDTO 
     * @param request 
     */
    @Post('/updateZone')
    async updateZone(@Body() zoneMasterDTO: ZoneMasterDTO,@Req() request:Request): Promise<ZoneResponseModel> {
        try {
            return await this.zoneMasterService.createZone(zoneMasterDTO, true,request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(ZoneResponseModel, error)
        }
    }
    /**
     * get All Zones
     * @param request 
     */
    @Post('/getAllZones')
    async getAllZones(@Req() request: Request): Promise<AllZonesResponseModel> {
        try {
        return await this.zoneMasterService.getAllZones();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllZonesResponseModel, error)
        }
    }
    @Post('/getPlantZones')
    async getPlantZones(@Body() plantIdRequest: PlantRequest): Promise<AllZonesResponseModel> {
        try {
            console.log('ttttttttttplantIdRequest');
            console.log(plantIdRequest);
        return await this.zoneMasterService.getPlantZones(plantIdRequest);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllZonesResponseModel, error)
        }
    }
    @Post('/getAllActiveZones')
  async getAllActiveZones(@Req() request: Request): Promise<AllZonesResponseModel> {
      try {
          return await this.zoneMasterService.getAllActiveZones();
      } catch (error) {
          return this.applicationExceptionhandler.returnException(AllZonesResponseModel, error)
      }
  }
    /**
     * Active or deactive Zone
     * @param VehicleReq 
     */
    @Post('/activateOrDeactivateZone')
    async activateOrDeactivateZone(@Body() VehicleReq: ZoneRequest): Promise<ZoneResponseModel> {
        try {
            return await this.zoneMasterService.activateOrDeactivateZone(VehicleReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(ZoneResponseModel, err);
        }
    } 
     @Post('/getAllZoneDropDown')
     async getAllZoneDropDown(): Promise<ZoneDropDownResponseModel> {
         try {
          return await this.zoneMasterService.getAllZoneDropDown();
        } catch (error) {
             return this.applicationExceptionhandler.returnException(ZoneDropDownResponseModel, error);
        }
      }
 
      @Post('/getZoneById')
      async getZoneById(@Body() zonereq: ZoneRequest): Promise<ZoneDropDownDto> {
          try {
              return await this.zoneMasterService.getZoneById(zonereq.zoneId);
          } catch (err) {
              throw err;
          }
      }
      @Post('/getPlantZonesExceptFromZone')
    async getPlantZonesExceptFromZone(@Body() plantIdRequest:PlantRequest): Promise<AllZonesResponseModel> {
        try {
            return await this.zoneMasterService.getPlantZonesExceptFromZone(plantIdRequest);
        } catch (err) {
            throw err;
        }
    }
}
